import request from '@/utils/request'

const validate = (
  name,
  username,
  password,
  sourceCode,
  inviteCode,
  bankCode,
  bankAccountName,
  bankAccountNo,
  currency
) => {
  return request({
    url: '/api/account/validate',
    method: 'post',
    data: {
      name,
      username,
      password,
      sourceCode,
      inviteCode,
      bankCode,
      bankAccountName,
      bankAccountNo,
      currency
    }
  })
}

const register = (
  name,
  username,
  password,
  sourceCode,
  inviteCode,
  bankCode,
  bankAccountName,
  bankAccountNo,
  currency
) => {
  return request({
    url: '/api/account',
    method: 'post',
    data: {
      name,
      username,
      password,
      sourceCode,
      inviteCode,
      bankCode,
      bankAccountName,
      bankAccountNo,
      currency
    }
  })
}

const getProfile = () => {
  return request({
    url: '/api/account/profile',
    method: 'get'
  })
}

const updateProfile = (name, bankCode, bankAccountName, bankAccountNo) => {
  return request({
    url: '/api/account/profile',
    method: 'put',
    data: {
      name: name,
      bankCode: bankCode,
      bankAccountName: bankAccountName,
      bankAccountNo: bankAccountNo
    }
  })
}

const updateBankAccountName = (bankCode, bankAccountName) => {
  return request({
    url: '/api/account/bankAccountName',
    method: 'put',
    data: {
      bankCode: bankCode,
      bankAccountName: bankAccountName
    }
  })
}

const changePassword = (oldPassword, newPassword) => {
  return request({
    url: '/api/account/changepwd',
    method: 'put',
    data: {
      oldPassword: oldPassword,
      newPassword: newPassword
    }
  })
}

export default {
  validate,
  register,
  getProfile,
  updateProfile,
  updateBankAccountName,
  changePassword
}
